module.exports = __webpack_public_path__ + "img/pantalla-6-3-2.3f102455.png";